export const useDeepLinkStore = defineStore('deep-links', () => {
  const destination = ref('');

  const hasDestination = computed(() => destination.value.length > 0);

  async function consumeDestination() {
    const value = destination.value;
    destination.value = '';

    return value;
  }

  return { destination, hasDestination, consumeDestination };
});